export default "__VITE_ASSET__CZFdE0lN__"